export class FileNameHelpers {

  static getFileNameToSplit(fileName: any) {
    let fileNameToSplit = "";
    if (typeof fileName !== "string") {
      fileNameToSplit = fileName.name || "";
    } else {
      fileNameToSplit = fileName;
    }
    return fileNameToSplit;
  }
  static getFileNameExtensionUppercase(fileName : string) {
    return FileNameHelpers.getFileNameToSplit(fileName).split(".").pop().toUpperCase();
  }

  static getFileNameWithoutPath(fileName : string) {
    return FileNameHelpers.getFileNameToSplit(fileName).split('\\').pop().split('/').pop();
  }

  static getFileAttachmentImage(fileName) {
    
    switch (FileNameHelpers.getFileNameToSplit(fileName).split('.').pop().toUpperCase()) {
      case "PDF":
      case "PPT":
      case "PPTX":  
        return "/assets/img/layout/bekijkook/bekijkook-rood.svg";
      case "DOCX":  
      case "DOC":
      case "JPG":
        return "/assets/img/layout/bekijkook/bekijkook-blauw.svg";
      case "XLSX":  
      case "XLS":
      case "PNG":
        return "/assets/img/layout/bekijkook/bekijkook-groen.svg";
      case "ZIP":
      case "RAR":
        return "/assets/img/layout/bekijkook/bekijkook-paars.svg";
      case "MP3":
      case "MP4":
      case "WAV":
      case "MOV":
        return "/assets/img/layout/bekijkook/bekijkook-grijs.svg";
      default:
        return "";
    }
  }
}